module.exports = __webpack_public_path__ + "img/hotelview.2b739629.png";